<div class="row">
  <div class="col-md-3">&nbsp;</div>
  <div class="col-md-6">
    <ta-password-forgot></ta-password-forgot>
  </div>
  <div class="col-md-3">&nbsp;</div>
</div>